<!-- @format -->
<template>
	<div class="pcp-header-wrap">
		<div class="left">
			<pcp-header-logo-name />
			<slot name="systems-slot"></slot>
		</div>
		<div class="right">
			<slot name="systems-slot-right"> </slot>
			<pcp-header-my-systems v-if="isShowMySystems && showMySystems" />
			<pcp-header-message style="margin-right: 30px" />
			<pcp-header-menu>
				<template #menu-front>
					<slot name="menu-front"></slot>
				</template>
				<template #menu-last>
					<slot name="menu-last"></slot>
				</template>
			</pcp-header-menu>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useGlobalStoreWithOut } from '@power/runtime-vue3';
	import PcpHeaderMySystems from './pcp-header-my-systems-new.vue';
	import PcpHeaderLogoName from './pcp-header-logo-name.vue';
	import PcpHeaderMenu from './pcp-header-menu.vue';
	import PcpHeaderMessage from './pcp-header-message/index.vue';

	interface Props {
		name?: string;
		isShowHeaderHome?: boolean; //是否展示home首页小图标
		isShowMySystems?: boolean; //是否展示我的应用、菜单小图标
		isShowHeaderName?: boolean; //logo组件里的name标题显示动态还是固定
	}

	const props = withDefaults(defineProps<Props>(), {
		isShowHeaderHome: true,
		isShowMySystems: true,
		isShowHeaderName: false,
	});
	const globalStore = useGlobalStoreWithOut();
	defineEmits(['update:modelValue']);
	provide('isShowHeaderName', props.isShowHeaderName);
	const showMySystems = !(globalStore.subSystems.length === 1);
</script>

<style scoped lang="scss">
	.pcp-header-wrap {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.right {
			display: flex;
			align-items: center;
		}
	}
</style>
